import script from "./STDSDC05C06AccessAuthority.vue?vue&type=script&setup=true&lang=js"
export * from "./STDSDC05C06AccessAuthority.vue?vue&type=script&setup=true&lang=js"

import "./STDSDC05C06AccessAuthority.vue?vue&type=style&index=0&id=44597467&scoped=true&lang=css"

import exportComponent from "D:\\TDS\\40_製造(M)\\99_電帳法_USE\\Tatsuzin_filemanage\\vue\\tdsvue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44597467"]])

export default __exports__